__turbopack_context__.v({
  "icon": "ProfileSocialLink-module__HHg82W__icon",
  "root": "ProfileSocialLink-module__HHg82W__root",
});
